import { render, staticRenderFns } from "./TopicReports.vue?vue&type=template&id=337cfa25&scoped=true&"
import script from "./TopicReports.vue?vue&type=script&lang=js&"
export * from "./TopicReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337cfa25",
  null
  
)

export default component.exports